import Config from "@/services/Config";

export default {
    "btn.login": "ログイン",
    "nodata.found": "データがありません。",
    "error.happen": "エラーが発生しました。",
    "file.not.found": "ファイルが見つかりません。",
    "0001": "みずほ銀行",
    "0009": "三井住友銀行",
    "0005": "三菱東京UFJ銀行",
    "9900": "ゆうちょ銀行",
    "0036": "楽天銀行",
    "0033": "PayPay銀行",
    "0038": "ドコモSMTBネット銀行",
    "0034": "セブン",
    "profile.error.required": "入力必須項目となります。",
    "profile.purpose.error.required": "FX投資目的入力必須項目となります。",
    "profile.update.error.field.required": "入力必須項目となります。",
    "profile.error.password.invalid": "新しいパスワードは6〜12文字の英数字をご入力ください。",
    "profile.error.password.not_match": "パスワードが正しくありません。",
    "profile.update.error.current_password.incorrect": "パスワードが正しくありません。",
    "profile.email.invalid": "無効なメールアドレス",
    "profile.update.error.email.exits": "このメールアドレスは既に登録されています。",
    "profile.error.sepecial_characters": "数字7桁で記入してください。",
    "profile.error.invalid_number": "数字以外は使用できません。",
    "profile.update.error.phone.invalid": "電話番号は10桁以上11桁以内でご入力ください。",
    "profile.update.error.MSG_TRS_NAB_0010": "更新は失敗しました。",
    "profile.error.file_size": "ファイルサイズの最大限は5Mです。",
    "profile.error.file_type": "アップロードファイルの形式は {param1}のいずれかです。",
    "profile.error.file_duplicate": "同じファイル名はアップロードできません。",
    "profile.message.below_bo_max_loss_amount": "※みんなのオプションにおける、1日あたりの損失上限額をご入力ください。",
    "MSG_NAB049_FINANCIAL_INFO": "金融資産は投資可能金額と同じかそれ以上にしてください",
    "profile.message.update.success": "依頼を受付けました。",
    "profile.update.success.indv.change_name_address": "依頼を受付けました。<br/><br/>■氏名変更<br/>変更後の氏名が記載されている本人確認書類のご提出が必要です。<a href=\"{param1}\" target=\"_blank\">本人確認書類アップロード</a>より送信をお願いいたします。<br/><br/>■住所変更<br/>変更後の住所が記載されている本人確認書類のご提出が必要です。<a href=\"{param1}\" target=\"_blank\">本人確認書類アップロード</a>より送信をお願いいたします。<br/><br/>※アップロード以外の送付方法や提出書類の詳細は、<a href=\"{param2}\" target=\"_blank\">必要書類について</a>をご覧ください。",
    "profile.update.success.corp.change_name_address": "依頼を受付けました。<br/><br/>登録情報の変更手続きは、下記書類の受領をもって進めて参ります。<br/>下記書類が未提出の場合は、該当箇所のアップローダーまたはご郵送にてご対応ください。<br/><br/>■法人名・法人住所の変更<br/>変更後の情報が記載されている履歴事項全部証明書（発行から3ヶ月以内）のご提出が必要です。<br/>また、法人番号指定通知書を未提出のお客様は原則、法人番号指定通知書のご提出も必要となります。<br/><br/>■代表者氏名・取引担当者氏名・取引担当者住所の変更<br/>変更後の情報が記載されている本人確認書類のご提出が必要です。<br/>取引担当者と代表者が同一の場合、変更後の情報が記載されている履歴事項全部証明書（発行から3ヶ月以内）のご提出も必要です。<br/><br/>※郵送の宛先や提出書類の詳細は、<a href=\"{param1}\" target=\"_blank\">必要書類について</a>をご覧ください。<br/>※お送りいただきました書類は返却いたしません。あらかじめご了承ください。",
    "profile.update.success.corp.change_name_address_benefic": "ご住所・お名前・代表者・担当者の変更・実質的支配者の追加および変更の場合ご住所・お名前が記載されている本人確認書類を別途ご送付いただく必要がございます。本人確認書類の<a href  =\"https://www.min-st.jp/documentupload/\" target=\"_blank\">アップロードフォーム</a>からアップロードしていただくか、Eメール、または郵送で弊社までお送りください。ご利用いただける本人確認書類と送付先は<a href=\"http://www.min-st.jp/service/other/document/\">こちら</a>をご確認ください。",
    "profile.update.success.corp.owner": "ご住所・お名前・代表者・担当者の変更・実質的支配者の追加および変更",
    "profile.update.success.corp.notowner": "ご住所・お名前・代表者・担当者の変更",
    "profile.update.success.indv.change_name_address.uploadFile": "依頼を受付けました。",
    "profile.update.success.corp.change_name_address.uploadFile": "依頼を受付けました。<br/><br/>■法人名・法人住所・代表者氏名の変更<br/>変更後の情報が記載されている履歴事項全部証明書（発行から3ヶ月以内の原本）のご郵送が必要です。<br/>また、法人番号指定通知書を未提出のお客様は、原則、ご郵送の際に法人番号指定通知書のコピーも同封ください。<br/><br/>■取引担当者氏名・取引担当者住所の変更<br/>取引担当者と代表者が同一の場合、変更後の情報が記載されている履歴事項全部証明書（発行から3ヶ月以内の原本）のご郵送が必要です。<br/><br/>※郵送の宛先や提出書類の詳細は、<a href=\"{param1}\" target=\"_blank\">必要書類について</a>をご覧ください。<br/>※お送りいただきました書類は返却いたしません。あらかじめご了承ください。",
    "profile.update.notify.request.accepted": "お客様情報を変更しました。",
    "profile.update.error.password.invalid": "※パスワードは6〜12文字以内で、半角英数字および記号が使用可能です。 <br> ※半角の英字、数字を1文字以上含めなければなりません。",
    "profile.error.sefl_assets.hedge_amount_conflick_corp": "ヘッジ目的の金額を変更いただく必要がございます。変更が完了しますと事業体の自己資本が更新されます。",
    "profile.error.sefl_assets.hedge_amount_conflick_indv": "ヘッジ目的の金額を変更いただく必要がございます。変更が完了しますと自己資産が更新されます。",
    "profile.label.upload.mynumber.msg.success": "マイナンバー書類を受付けました。不備がある場合には、ご連絡をさせていただきます。",
    "profile.label.upload.mynumber.msg.fail": "エラーが発生しました。再度アップロードしてください。",
    "profile.label.upload.mynumber.msg.size": "ファイルサイズの最大限は5Mです。",
    "profile.update.notify.request.confirm.mail.success": "依頼を受付けました。<br><br>変更後のメールアドレスへ確認メールを送信いたしました。<br>30分以内に、メールに記載の認証URLにてメール認証を行ってください。<br>認証後、メールアドレスの変更が完了となります。<br>",
    "profile.update.notify.request.confirm.mail.error": "メールをクライアントに送信中にエラーが発生しました",
    "profile.error.mail_confirm.not.matching": "メールアドレスの入力が一致しません。 ",
    "profile.error.authen_key": "認証コードが正しくありません。再度入力ください。 ",
    "MSG_TRS_NAF_0208": "みんなのFX口座をお持ちで、変更がお済でない場合はみんなのFXの金融資産情報の変更をお願いいたします。",

    "msg_trs_naf_0060": "バイナリー損失額上限は、1万円で入力してください。",
    "msg_trs_naf_0061": "バイナリー損失額上限は、1万円から2万円の範囲で設定してください。",
    "msg_trs_naf_0062": "バイナリー損失額上限は、1万円から5万円の範囲で設定してください。",
    "msg_trs_naf_0063": "バイナリー損失額上限は、1万円から12万円の範囲で設定してください。",
    "msg_trs_naf_0064": "バイナリー損失額上限は、1万円から25万円の範囲で設定してください。",
    "msg_trs_naf_0065": "バイナリー損失額上限は、1万円から50万円の範囲で設定してください。",
    "msg_trs_naf_0066": "バイナリー損失額上限は、1万円から125万円の範囲で設定してください。",
    "msg_trs_naf_0067": "バイナリー損失額上限は、1万円から250万円の範囲で設定してください。",
    "msg_trs_naf_0068": "バイナリー損失額上限は、1万円から500万円の範囲で設定してください。",
    "msg_trs_naf_0102": "（自己資産の20分の1以内）で設定してください。",
    "msg_trs_naf_0103": "（自己資産の20分の1以内）で設定してください。",
    "msg_trs_naf_0061_msg_trs_naf_0102": " バイナリー損失額上限は、1万円から2万円の範囲、かつ投資可能資産の20分の1以内で設定してください。",
    "msg_trs_naf_0061_msg_trs_naf_0103": " バイナリー損失額上限は、1万円から2万円の範囲、かつ事業体の自己資本の20分の1以内で設定してください。",
    "msg_trs_naf_0062_msg_trs_naf_0102": "バイナリー損失額上限は、1万円から5万円の範囲、かつ投資可能資産の20分の1以内で設定してください。",
    "msg_trs_naf_0062_msg_trs_naf_0103": "バイナリー損失額上限は、1万円から5万円の範囲、かつ事業体の自己資本の20分の1以内で設定してください。",
    "msg_trs_naf_0063_msg_trs_naf_0102": "バイナリー損失額上限は、1万円から12万円の範囲、かつ投資可能資産の20分の1以内で設定してください。",
    "msg_trs_naf_0063_msg_trs_naf_0103": "バイナリー損失額上限は、1万円から12万円の範囲、かつ事業体の自己資本の20分の1以内で設定してください。",
    "msg_trs_naf_0064_msg_trs_naf_0102": "バイナリー損失額上限は、1万円から25万円の範囲、かつ投資可能資産の20分の1以内で設定してください。",
    "msg_trs_naf_0064_msg_trs_naf_0103": "バイナリー損失額上限は、1万円から25万円の範囲、かつ事業体の自己資本の20分の1以内で設定してください。",
    "msg_trs_naf_0065_msg_trs_naf_0102": "バイナリー損失額上限は、1万円から50万円の範囲、かつ投資可能資産の20分の1以内で設定してください。",
    "msg_trs_naf_0065_msg_trs_naf_0103": "バイナリー損失額上限は、1万円から50万円の範囲、かつ事業体の自己資本の20分の1以内で設定してください。",
    "msg_trs_naf_0066_msg_trs_naf_0102": "バイナリー損失額上限は、1万円から125万円の範囲、かつ投資可能資産の20分の1以内で設定してください。",
    "msg_trs_naf_0066_msg_trs_naf_0103": "バイナリー損失額上限は、1万円から125万円の範囲、かつ事業体の自己資本の20分の1以内で設定してください。",
    "msg_trs_naf_0067_msg_trs_naf_0102": "バイナリー損失額上限は、1万円から250万円の範囲、かつ投資可能資産の20分の1以内で設定してください。",
    "msg_trs_naf_0067_msg_trs_naf_0103": "バイナリー損失額上限は、1万円から250万円の範囲、かつ事業体の自己資本の20分の1以内で設定してください。",
    "msg_trs_naf_0068_msg_trs_naf_0102": "バイナリー損失額上限は、1万円から500万円の範囲、かつ投資可能資産の20分の1以内で設定してください。",
    "msg_trs_naf_0068_msg_trs_naf_0103": "バイナリー損失額上限は、1万円から500万円の範囲、かつ事業体の自己資本の20分の1以内で設定してください。",

    "finalassets.less_than_3": "30万円未満",
    "finalassets.3_10": "30万円～100万円未満",
    "finalassets.10_25": "100万円～250万円未満",
    "finalassets.25_50": "250万円～500万円未満",
    "finalassets.50_100": "500万円～1000万円未満",
    "finalassets.100_250": "1000万円～2500万円未満",
    "finalassets.250_500": " 2500万円～5000万円未満",
    "finalassets.500_1000": "5000万円～1億円未満",
    "finalassets.over_1000": "1億円以上",

    "bank.account.save.success": "お客様の出金先口座 の作成が完了しました。",
    "bank.account.update.success": "出金先口座を登録 の更新は正常に行われました。",
    "bank.account.delete.success": "出金先口座を登録 を削除しました。",
    "bank.account.update.fail": "Update account information was fail",
    "bank.account.delete.fail": "Delete account information was fail",
    "bank.account.input.required": "入力必須項目となります。",
    "bank.account.input.not_number": "無効な口座番号",
    "bank.account.input.max_length": "口座番号は間違えています。英字から始まる7桁で記入してください。",
    "bank.account.status.text1": "現在、出金口座の変更手続き中です。登録完了まで今しばらくお待ちください。",
    "bank.account.status.text2": "現在、出金処理中です。出金完了まで出金先口座の変更は行えません。",
    "bank.account.status.text3": "出金先口座の変更をご依頼いただいた場合、新しい出金先口座の登録完了までの間は、出金依頼を行えません。予めご了承ください。",
    "bank.account.message.success": "依頼を受付けました。",
    "confirm.delete.bank_account": "Are you sure to delete this account?",

    "ams.customer.news.update.success": "依頼を受付けました。",
    "ams.customer.news.update.fail": "エラーが発生しました。",

    "deposit.alert.danger.part1_1": "・ダイレクト入金の場合、最低入金額は",
    "deposit.alert.danger.part1_2": "となります。",
    "deposit.alert.danger.part2": "・振込人名義は、ＬＩＧＨＴ　ＦＸの登録名義と同一に限ります。振込人名義が登録名義と相違している場合、ご入金を承ることができない場合がございます。",
    "deposit.alert.danger.part3": "・取引口座間の資金移動は振替画面にて行ってください。",
    "deposit.alert.danger.part4_0": "・ダイレクト入金は即時入金を保証するものではありません。",
    "deposit.alert.danger.part4_1": "・その他のダイレクト入金の注意事項詳細および提携金融機関については",
    "deposit.alert.danger.part4_2": "入出金・振替",
    "deposit.alert.danger.part4_3": "をご覧ください。",
    "deposit.alert.input.required": "入力必須項目となります。",
    "deposit.alert.virtual_acc_1": "・振込入金の場合、手数料はお客様負担となります。また、入出金口座に入金金額が反映されるまでにお時間がかかります。あらかじめご了承ください。",
    "deposit.alert.virtual_acc_3": "・振込人名義は、ＬＩＧＨＴ　ＦＸの登録名義と同一に限ります。振込人名義が登録名義と相違している場合、ご入金を承ることができない場合がございます。",
    "deposit.alert.virtual_acc_4": "・取引口座間の資金移動は振替画面にて行ってください。",
    "deposit.alert.virtual_acc_5_1": "・その他の振込入金の注意事項詳細については",
    "deposit.alert.virtual_acc_5_2": "入出金・振替",
    "deposit.alert.virtual_acc_5_3": "をご覧ください。",

    "withdraw.error.require": "入力必須項目となります。",
    "withdraw.error.format": "フィールドが正しい数値でなければなりません。",
    "withdraw.no.auth": "現在logined顧客に属していない要求をキャンセルすることはできません。",
    "withdrawal_cannot_cancel": "出金の取消をすることができませんでした。",

    "transfer.error.required": "振替金額 が必要です。",
    "transfer.error.number_required": "このフィールドは数値でなければなりません。",

    "customer.news.messagekind.notification": "お知らせ",
    "customer.news.messagekind.important": "重要",
    "customer.news.messagekind.campaign": "キャンペーン",
    "customer.news.messagekind.seminar": "セミナー",
    "customer.news.messagekind.maintenance": "メンテナンス",
    "customer.news.messagekind.other": "その他",
    "customer.agree.accept": "承諾する",
    "customer.agree.yes": "はい",
    "customer.agree.no": "いいえ",
    "customer.agree.saveAgree": "マイページへ",

    "crypto_regis.warning": "各種規定や確認事項にすべて承諾または「はい」をご選択いただきますと、取引画面へ進めます。\n",
    "username.error.sepecial_characters": " ユーザー名はアルファベットもしくは1から9の正数です。",

    "MSG_TRS_NAF_0174": "現在の時間は、入出金および振替操作はできません。</br> 詳細については、<a href=\"https://lightfx.jp/service/outline/\" target=\"_blank\">こちら</a>をご確認ください。",
    "MSG_TRS_NAF_0008": "※パスワードは10〜64文字以内で、半角英数字および記号が使用可能です。",
    "MSG_TRS_NAF_0008_1": "※半角の英字、数字を1文字以上含めなければなりません。",
    "MSG_NAB115": "ログインIDを入力してください。",
    "MSG_NAB116": "パスワードを入力してください。",
    "MSG_NAB117": "ID又はパスワードが違います。",
    "MSG_SC_014": "検索開始日は検索終了日と同じかそれ以下にしてください",
    "MSG_NAB039": "依頼中のものがなくなりましたので、取消できませんでした。",
    "FE_MSG019": "ToはFromより後の時刻を指定してください。",
    "MSG_TRS_NAF_0087": "アップロードファイルを選択してください。",
    "MSG_TRS_NAF_0179": "PDF作成処理は進行中です。 しばらくお待ちください。",
    "MSG_NAB050": "出金予約を受付けました。",
    "MSG_NAB040": "出金予約を取消しました。",
    "MSG_NAB022": "出金金額が出金可能額を上回っています。入出金口座へ資金振替を行ってから出金予約をしてください。",
    "MSG_NAB026": "出金金額が出金可能額を上回っています。",
    "MSG_NAB021": "出金に対する権限はありません。",
    "MSG_TRS_NAF_0099": "取引に制限がかかっております。 カスタマーサポートまでご連絡ください。",
    "MSG_TRS_NAF_0148": "口座番号の桁数が不足しています。数字7桁で記入してください。",
    "MSG_TRS_NAF_0149": "数字7桁で記入してください。",
    "MSG_NAF0003": "すでに出金予約されているため受付けることができません。出金予約を取消してから再度登録してください。",
    "MSG_NAB057": "有効な金額を入力してください。",
    "MSG_NAF001": "入力必須項目となります。",
    "MSG_NAB118": "お客様の出金予約はキャンセルされました。",
    "MSG_NO_BANK": "出金口座が登録されていません",
    "MSG_NO_AMOUNT": "入力金額してください！",
    "MSG_NAB101": "出金金額は最小出金手数料より多くなければなりません:{param1}",
    "MSG_NAB013": "{param1} 正の数である",
    "MSG_TRS_NAF_0190": "ファイルの添付をしてください。",
    "MSG_TRS_NAF_0192": "現在{param0}はメンテナンス中です",
    "MSG_TRS_NAF_0193": "現在{param0}はメンテナンス中のため、入出金および振替操作はできません。</br/> 詳細については、<a href=\"https://lightfx.jp/service/outline/\" target=\"_blank\">こちら</a>をご確認ください。",
    "MSG_TRS_NAF_0194": "現在一部のサービスがメンテナンス中のため、終了まで変更できません。",
    "MSG_TRS_NAF_0195": "現在{param0}はメンテナンス中のため、終了まで{param0}のレポートは閲覧できません。",
    "MSG_TRS_NAF_0196" : "エラーが発生いたしました",
    "MSG_TRS_NAF_0088": "ファイルサイズの最大限は5Mです",
    "MSG_TRS_NAF_0086": "アップロードファイルの形式は {param1}のいずれかです。",
    "MSG_TRS_NAF_0151": "指定されたファイルが存在しません。再度ファイルを指定してください。",
    "MSG_TRS_NAF_0191": "出金先口座は既に認証済みです。",
    "MSG_FCM_007": "ウィンドウを閉じてもよろしいですか？",
    "MSG_NAB011": "口座番号は既に存在しました。",
    "ERR_MSG_BRANCH_NOT_EXISTS": "分岐が存在しません",
    "MSG_NAB001": "入力必須項目となります。",
    "MSG_NAB091_TRANFER": "口座が有効ではない為 口座に振り替えることは出来ません。",
    "MSG_NAB015": "振替が失敗しました。",
    "MSG_NAB014": "資金振替が成功しました。",
    "MSG_TOO_LONG": "長すぎます！",
    "MSG_NAB029": "振替金額が振替可能額を上回っています。",
    "MSG_NAB095": "振替金額は{param1}以上を指定してください。",
    "MSG_NAB030": "振込に対する権限はありません。",
    "MSG_NAB091": "{0}が有効ではない為、{0}に振り替えることは出来ません。",
    "MSG_NAB114": "振替処理が失敗しました。",
    "MSG_TRS_NAF_0051": "このメールアドレスは既に登録されています。",
    "MSG_TRS_NAF_0069": "バイナリーに口座への振替は知識確認テストに合格する必要があります。 <br/>テストは<a href=\"{param1}\">こちら</a>",
    "MSG_TRS_NAF_0123": "Fromの日付を設定してください。",
    "MSG_TRS_NAF_0124": "Toの日付を設定してください。",
    "MSG_TRS_NAF_0150": "検索可能期間は、過去2年以内となります。",
    "MSG_TRS_NAF_0125": "FromとToの日付を設定してください。",
    "MSG_TRS_NAF_0099_MAX_LENGTH": "{param1}は21文字以上は書き込めません",
    "MSG_TRS_NAF_0004_param": "{param1}入力必須項目となります。",
    "MSG_TRS_NAF_0005_param": "{param1}は入力必須となります。",
    "MSG_TRS_NAF_0004_BO": "{param1}は必須項目となります。",
    "MSG_TRS_NAF_0004": "入力必須項目となります。",
    "MSG_TRS_NAF_0120": "{param1}は41文字以上は書き込めません。",
    "MSG_TRS_NAF_0126": "生年月日を確認してください。",
    "MSG_TRS_NAF_0134": "振込入金用の口座作成時にエラーが発生いたしました。  <br/>エラーが発生し続ける場合には、マイページのお客様サポートよりお問い合わせください。",
    "MSG_TRS_NAF_0136": "認証コードは入力必須項目となります。",
    "MSG_TRS_NAF_0155": "6桁でご入力ください。",
    "MSG_TRS_NAF_0131": "認証コードが正しくありません。<br/>再度入力してください。",
    "MSG_TRS_NAF_0137": "入力必須項目、または編集が必要な項目があります。",
    "MSG_NAB005": "エラーが発生しました。",
    "MSG_TRS_NAF_0197": "ご入力いただいたパスワードは設定いただけません。",
    "MSG_TRS_NAF_0198": "振替可能額が0円未満の口座があるため、出金できません。",
    "MSG_TRS_NAF_0113": "パスワードが正しくありません。",
    "MSG_NAB205": "入力のドメインはご使用いただけません。",

    // password message
    "password.message.input_pass1": "※他のインターネットサイトで使用しているパスワードを設定するのはお控えください。",
    "password.message.input_pass2": "※パスワードは10〜64文字以内で、半角英大文字、小文字、数字、記号の4種類から2種類以上を組み合わせてください。",
    "password.message.input_pass3": "※以下のご登録情報から推測できる内容は設定いただけません。",
    "password.message.input_pass4": "・個人のお客様（メールアドレス、生年月日、電話番号）",
    "password.message.input_pass5": "・法人のお客様（メールアドレス、設立年月、電話番号）",
    "password.message.input_pass6": "※パスワードについて詳しくは<a href=\"{supportSecurityUrl}\" target=\"_blank\">こちら</a>をご覧ください。",
    "password.message.input_pass9": "半角英数字記号10～64文字以内",
    "password.message.input_pass10": "新しいパスワードを再入力",

    // second password messages
    "password2.message.input_pass1": "※他のインターネットサイトで使用しているパスワードを設定するのはお控えください。",
    "password2.message.input_pass1.1": "※パスワードは<span style='color: red'>4〜64文字以内</span>で、半角英大文字、半角英小文字、数字、記号の4種類から<span style='color: red'>2種類以上</span>を組み合わせてください。",
    "password2.message.input_pass2": "※パスワードは<span style='color: red'>4〜64文字以内</span>で、半角英大文字、半角英小文字、数字、記号の4種類から<span style='color: red'>2種類以上</span>を組み合わせてください。",
    "password2.message.input_pass2.1": "※2023年09月16日以降に1度でもご利用いただいたパスワードは設定いただけません。",
    "password2.message.input_pass3": "※ご登録情報から推測できる内容（生年月日、電話番号、メールアドレス）は設定いただけません。",
    "password2.message.input_pass3.1": "※「ログインパスワード」と同一のパスワードは登録できません。",
    "password2.message.input_pass3.2": "※「第2パスワード」と同一のパスワードは登録できません。",
    "password2.message.input_pass4": "※以下のご登録情報から推測できる内容は設定いただけません。",
    "password2.message.input_pass5.1": `※パスワードについて詳しくは<a href='${Config.getSupportSecurityUrl()}' target='_blank'>こちら</a>をご覧ください。`,
    "password2.message.input_pass6": "半角英数字記号4～64文字以内",
    "password2.message.note1": "第2パスワードの設定について　（登録が必須になります）",
    "password2.message.note2": "当社では2023年9月16日よりログインパスワードとは別に第三者の不正出金等の防止を強化するために第2パスワードを導入いたしました。以下内容をご確認のうえ設定をお願いいたします。",
    // "password2.message.note3": "第２パスワードを導入いたしました。下記内容をご確認のうえ設定をお願いいたします",
    "password2.message.note4": "第2パスワードが必要な画面は下記になります。",
    "password2.message.note5": "<span style='color:red;font-weight: bold;'>①出金画面</span>　（出金手続きを行う時に必要です）",
    "password2.message.note6": "<span style='color:red;font-weight: bold;'>②報告書閲覧・お客様情報の確認</span>　（報告書閲覧、お客様情報を確認するときに必要です）",
    "password2.message.note8": "注意",
    "password2.message.note9": "※①②のパスワードは<span style='color:red;'>同じ</span>パスワードです。",
    "password2.message.note10": "※ログインパスワードと第2パスワードは<span style='color:red;'>違う</span>パスワードです。",
    "password2.message.note11": "※第2パスワードの変更はお客様情報画面でできます。",
    "password2.message.note12": "出金におけるセキュリティー設定　　※2段階認証（2FA）",
    "password2.message.note13": "※2段階認証（FA）の設定は任意です　　（設定をしなくても出金は可能です）",
    
    //2nd password is wrong
    "MSG_TRS_NAF_0200": "第2パスワードが違います",
    // Authentication has been completed.
    "MSG_TRS_NAF_0201": "認証が完了しました。",
    //Removed masking.
    "MSG_TRS_NAF_0202": "マスキングを削除いたしました。",
    //We have authenticated. Viewing of the report is available.
    "MSG_TRS_NAF_0203": "認証いたしました。報告書の閲覧がご利用いただけます。",
    //The second password is locked (Waiting JP confirm)
    "MSG_TRS_NAF_0204": "第2パスワードの誤りが一定回数を超えたため、再設定が必要です。",
    //Second password reset completed.
    "MSG_TRS_NAF_0205": "第2パスワードのリセットが完了しました。",
    "MSG_TRS_NAF_0207": "第2パスワードの設定が必要です。",
    "browser.not_support.content": "ご利用のブラウザ は、本ツールに対応しておりません。 </br> 他の推奨ブラウザ（ Chrome 、 FireFox または Microsoft Edge ）をご利用ください。",
    "browser.not_support.title": "お知らせ",
    "accept.news.error.required": "ご理解・承諾いただく必要があります。",
    "title_pass2_locked": "エラー",
    "message_pass2_locked": "第2パスワードの誤りが一定回数を超えたため、再設定が必要です。",
    "forgot_pass2_url": `!!`,
    "MSG_TRS_NAF_0212":  "出金可能額の範囲内でご入力ください。</br> 取引口座に資金がある場合は、「振替」より「入出金口座」に資金振替いただいた後に操作してください。",
    "MSG_TRS_NAF_0214":  "本人確認書類を受付けました。",
    "MSG_TRS_NAF_0071": "同じファイル名はアップロードできません。",
    "MSG_TRS_NAF_0215": "入力できない文字が含まれています",
    "MSG_TRS_NAF_0217": "認証コードが違います。",
    "MSG_TRS_NAF_0218": "パスキーの認証に失敗しました</br>繰り返しこの画面が表示される場合は<a href=\"{supportLink}\" target=\"_blank\">こちら</a>をご参照ください。",
    "MSG_TRS_NAF_0220": "パスキーの削除が完了しました",
    "MSG_TRS_NAF_0221": "パスキーの削除に失敗しました",
    "MSG_TRS_NAF_0222": "メインメールと追加メールの両方をOFFに設定することはできません。"
}
